import { render, staticRenderFns } from "./Seaweed.vue?vue&type=template&id=6ae875c4&scoped=true&"
import script from "./Seaweed.vue?vue&type=script&lang=js&"
export * from "./Seaweed.vue?vue&type=script&lang=js&"
import style0 from "./Seaweed.vue?vue&type=style&index=0&id=6ae875c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae875c4",
  null
  
)

export default component.exports